module.exports = __webpack_public_path__ + "static/img/img9.623fd31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/img9.png
// module id = ZMkW
// module chunks = 1